const RoleList = (props) => {
    const {roles, changeValues, role_id, fieldError, userRole, roleOptions} = props

    const handleSelect = (option) => {
        changeValues({role_id: option, role_name: roles.filter((d) => d.id === option)[0].name})
    }

    const selectedRole = roles.filter((d) => d.id === role_id)
    return (
        <div>
            <div className="mb-5">
                {roles.map((role, index) => {
                    if (userRole !== "Enterprise Admin" && (!!!roleOptions || !roleOptions.includes(role.name))) {
                        return null
                    }

                    return (
                        <div key={index} className="d-flex fv-row mb-5">
                            <div className="form-check form-check-custom form-check-solid">
                                <input
                                    className="form-check-input me-3"
                                    name="user_role"
                                    type="radio"
                                    checked={role.id === selectedRole[0]?.id}
                                    id={`id-role-option-${role.name.replace(/\s+/g, "-").toLowerCase()}`}
                                    onChange={() => handleSelect(role.id)}
                                />

                                <label
                                    className="form-check-label"
                                    htmlFor={`id-role-option-${role.name.replace(/\s+/g, "-").toLowerCase()}`}
                                >
                                    <div className="fw-bold">{role.name}</div>
                                    <div className="text-gray-800">{role.description}</div>
                                </label>
                            </div>
                            <div className="separator separator-dashed my-5"></div>
                        </div>
                    )
                })}
            </div>
            <div className="fv-plugins-message-container fv-plugins-message-container--enabled invalid-feedback">
                {fieldError}
            </div>
        </div>
    )
}

export default RoleList
